import { GlobalContext } from "Global/Base/GlobalContext";
import { EnumUtils } from "Global/Base/Utils/EnumUtils";

type CheckPointMapType = Map<string, CheckPointData>;

enum SupportedCheckPointNames {
    frameRightsEvaluatorBeginning = "frameRightsEvaluatorBeginning",
    frameRightsEvaluatorRightTypeBeforeSwitch = "frameRightsEvaluatorRightTypeBeforeSwitch",
    frameRightsEvaluatorRightTypeAfterSwitch = "frameRightsEvaluatorRightTypeAfterSwitch",
    frameRightsEvaluatorRightTypeBeforeServerEval = "frameRightsEvaluatorRightTypeBeforeServerEval",
    frameRightsEvaluatorRightTypeBeforeFormRightsAdd = "frameRightsEvaluatorRightTypeBeforeFormRightsAdd",
    frameRightsEvaluatorRightTypeBeforeItemRightsEval = "frameRightsEvaluatorRightTypeBeforeItemRightsEval",
    evaluateRightsOnComponentTreeBeforeOverrides = "evaluateRightsOnComponentTreeBeforeOverrides",
    evaluateOverridesOnControlRightType = "evaluateOverridesOnControlRightType",
    evaluateOverridesOnControlRightTypeBeforeSetToControlWrapper = "evaluateOverridesOnControlRightTypeBeforeSetToControlWrapper",
}

/**
 * TODO: WIP
 */
export class RightsDebugProbe {
    private static _enabled: boolean = true;
    public static get enabled(): boolean {
        return this._enabled;
    }
    public static set enabled(v: boolean) {
        this._enabled = v;
    }

    private static _supportedCheckpointNames: string[] = EnumUtils.getStringEnumValues(SupportedCheckPointNames);

    private static _checkPointMap: CheckPointMapType = new Map<string, CheckPointData>();

    public static get checkPointMap(): CheckPointMapType {
        return this._checkPointMap;
    }

    public static get supportedCheckPointNamesEnum(): typeof SupportedCheckPointNames {
        return SupportedCheckPointNames;
    }

    public static get supportedCheckPointNames(): string[] {
        return this._supportedCheckpointNames;
    }

    public static get registeredCheckPointNames(): string[] {
        return [...this._checkPointMap.keys()];
    }

    public static enable(): void {
        this.enabled = true;
    }

    public static disable(): void {
        this.enabled = false;
    }

    public static restoreCheckPointMap(checkPointMap: Map<string, IStoreCheckPointData>): void {
        for (const [checkPointName, restoredCheckPointData] of checkPointMap.entries()) {
            //this._checkPointMap.set(checkPointName)
            const currentCheckPointData = this.getOrCreateCheckpointDataForCheckpointName(checkPointName);

            for (const restoredBreakCondition of restoredCheckPointData._breakConditions) {
                currentCheckPointData.addBreakCondition(restoredBreakCondition._condition, restoredBreakCondition._enabled);
            }

            // TODO: restore methods?
        }
    }

    public static getOrCreateCheckpointDataForCheckpointName(checkPointName: string): CheckPointData {
        let checkPointData: CheckPointData | undefined = undefined;

        if (!(this._checkPointMap.has(checkPointName))) {
            checkPointData = new CheckPointData();
            this._checkPointMap.set(checkPointName, checkPointData);
        }

        if (!checkPointData) {
            checkPointData = this._checkPointMap.get(checkPointName)!;
        }

        return checkPointData;
    }

    public static registerBreakConditionForCheckpoint(checkPointName: string, breakConditionText: string, enabled: boolean = true): void {
        const checkPointData = this.getOrCreateCheckpointDataForCheckpointName(checkPointName);

        if (!checkPointData) {
            //log error // TODO
            return;
        }

        checkPointData.addBreakCondition(breakConditionText, enabled);
    }

    public static checkPoint(checkPointName: string): string { //, paramsObject: object /* , passedThis: any, contextFun: (fun: any) => any */ ): void { //[Function, CheckPointData] {
        if (this.enabled == false) {
            return "";
        }

        const checkPointData = this.getOrCreateCheckpointDataForCheckpointName(checkPointName);

        if (!checkPointData) {
            return "";
        }

        // //{ (new Function("checkPointData",
        // let evalBreakConditions = (() => {
        //     for (let breakCondition of checkPointData.breakConditions) {
        //         if (eval(breakCondition)) {
        //             debugger;
        //         }
        //     }
        // });

        // evalBreakConditions.call(paramsObject);

        // let resultCode = "(function () { \r\n";
        let resultCode = "{ \r\n";

        if (checkPointData.breakConditions?.length > 0) {
            const conditionsCodeArray = [];

            for (const breakCondition of checkPointData.breakConditions) {
                if (!breakCondition.enabled) {
                    continue;
                }

                const breakConditionText = breakCondition.condition;
                let conditionCode = "\tif (" + breakConditionText + ") {\r\n";
                conditionCode += "\t\tdebugger; } \r\n";
                conditionsCodeArray.push(conditionCode);
                //conditionsCodeArray.push(`(${breakCondition})`);
                /* if (eval(breakCondition)) {
                    debugger;
                } */
            }

            resultCode += conditionsCodeArray.join("\r\n\r\n");
            //resultCode += `\t\tdebugger; } \r\n`;
        }

        resultCode += "\r\n}";

        return resultCode;
    }

    //@ts-ignore
    private meth(checkPointData: CheckPointData): void {
        for (const breakCondition of checkPointData.breakConditions) {
            // if (eval(breakCondition)) {
            //     debugger;
            // }
            const newFunction = new Function(`
                if (${breakCondition}) {
                    debugger;
                }
            `);
            newFunction();
        }
    }
}

GlobalContext.registerType(RightsDebugProbe);

interface IStoreCheckPointData {
    _breakConditions: IStoredBreakCondition[];
}

interface IStoredBreakCondition {
    _condition: string;
    _enabled?: boolean;
}

class CheckPointData {
    constructor() {
        //this._breakConditions.push(new BreakCondition("rightType == 32 && controlWrapper.control.actionType == 3"));
    }

    private _breakConditions: BreakCondition[] = [];
    public get breakConditions(): BreakCondition[] {
        return this._breakConditions;
    }
    public set breakConditions(v: BreakCondition[]) {
        this._breakConditions = v;
    }

    // private _customMethods : ((() => any)[]) = [];
    // public get customMethods() : ((() => any)[]) {
    //     return this._customMethods;
    // }
    // public set customMethods(v : ((() => any)[])) {
    //     this._customMethods = v;
    // }

    public addBreakCondition(conditionText: string, enabled: boolean = true): void {
        this._breakConditions.push(new BreakCondition(conditionText, enabled));
    }

    public removeBreakCondition(breakCondition: BreakCondition): void {
        this._breakConditions = this._breakConditions.filter(item => item !== breakCondition);
    }
}

class BreakCondition {
    constructor(condition: string, enabled: boolean = true) {
        this.condition = condition;
        this.enabled = enabled;
    }

    private _condition: string | undefined = undefined;
    public get condition(): string | undefined {
        return this._condition;
    }
    public set condition(v: string | undefined) {
        this._condition = v;
    }

    private _enabled: boolean = false;
    public get enabled(): boolean {
        return this._enabled;
    }
    public set enabled(v: boolean) {
        this._enabled = v;
    }
}
